import styled from 'styled-components';

export const CollapseContent = styled.div`
  margin-top: 0.5rem;
  margin-left: 3.5rem;
  margin-right: 3.5rem;
`;
